/* Spring: Apple's damping + response spring for the web, in 2KB, no library (apple-design SKILL.md sections 3 to 6, 9).
   Built 8 Oct 2026 for the website builder skills. Copy into the brand's drafts/shared folder; this copy is the source.

   var x = Spring(0, function(v){ el.style.transform = 'translateX(' + v + 'px)' });
   x.to(300)                                  default: damping 1 (no overshoot), response 0.35s
   x.to(0, {damping: .8, velocity: v})        after a flick only: a little bounce, carrying the finger's speed
   x.track(px)                                during a drag: follows 1:1 and records speed for the release
   x.releaseVelocity()                        px/s over the last 100ms of the drag
   Spring.project(v)                          where a flick at v px/s would come to rest (Apple's decay, d 0.998)
   Spring.rubberband(over, size)              soft resistance past an edge

   Every .to() starts from the live value and the live velocity, so a moving element can be grabbed or
   sent back at any instant without a jump. Under prefers-reduced-motion, .to() lands at once; pages
   swap the slide for a short fade in CSS. */
(function(){
  var RM=window.matchMedia?matchMedia('(prefers-reduced-motion: reduce)'):{matches:false};
  function Spring(initial,onUpdate){
    var s={value:initial||0,velocity:0,target:initial||0},raf=0,last=0,cfg={},hist=[];
    function emit(){if(onUpdate)onUpdate(s.value)}
    function step(now){
      var dt=Math.min(.064,(now-last)/1000);last=now;
      /* stiffness and damping from Apple's two designer parameters (mass 1) */
      var k=Math.pow(2*Math.PI/cfg.response,2),c=4*Math.PI*cfg.damping/cfg.response,n=Math.max(1,Math.ceil(dt/(1/240))),h=dt/n;
      for(var i=0;i<n;i++){var a=-k*(s.value-s.target)-c*s.velocity;s.velocity+=a*h;s.value+=s.velocity*h}
      if(Math.abs(s.value-s.target)<cfg.precision&&Math.abs(s.velocity)<cfg.precision*10){s.value=s.target;s.velocity=0;raf=0;emit();if(cfg.onRest)cfg.onRest(s.value);return}
      emit();raf=requestAnimationFrame(step);
    }
    s.to=function(target,o){
      o=o||{};cfg={damping:o.damping!=null?o.damping:1,response:o.response||.35,precision:o.precision||.1,onRest:o.onRest};
      if(o.velocity!=null)s.velocity=o.velocity;s.target=target;hist=[];
      if(RM.matches||o.instant){s.stop();s.value=target;s.velocity=0;emit();if(cfg.onRest)cfg.onRest(target);return s}
      if(!raf){last=performance.now();raf=requestAnimationFrame(step)}
      return s;
    };
    s.track=function(v){s.stop();var t=performance.now();hist.push([t,v]);while(hist.length>2&&t-hist[0][0]>100)hist.shift();s.value=s.target=v;emit();return s};
    s.releaseVelocity=function(){if(hist.length<2)return 0;var a=hist[0],b=hist[hist.length-1],dt=(b[0]-a[0])/1000;
      /* a finger that stopped before lifting has no throw */
      if(performance.now()-b[0]>80||dt<=0)return 0;return (b[1]-a[1])/dt};
    s.jump=function(v){s.stop();s.value=s.target=v;s.velocity=0;emit();return s};
    s.stop=function(){if(raf)cancelAnimationFrame(raf);raf=0;return s};
    s.moving=function(){return !!raf};
    return s;
  }
  Spring.project=function(v,rate){rate=rate||.998;return (v/1000)*rate/(1-rate)};
  Spring.rubberband=function(over,size,c){c=c||.55;return (over*size*c)/(size+c*Math.abs(over))};
  Spring.reduced=function(){return RM.matches};
  window.Spring=Spring;
})();
